import { getScaledFont } from '@wix/thunderbolt-becky-root'
import { SelectionTagsListCssCarmiData, SelectionTagsListDefinition } from '@wix/thunderbolt-components-native'
import { withCompInfo } from '@wix/editor-elements-integrations'

export const css = withCompInfo<SelectionTagsListCssCarmiData, SelectionTagsListDefinition>()(
	// @ts-ignore - remove once isOneDocMigrated is added to CompInfo
	['compLayout', 'styleProperties', 'siteFonts', 'isMobileView', 'isOneDocMigrated', 'siteFontsSpxResolved'],
	// @ts-ignore - remove once isOneDocMigrated is added to CompInfo
	({ compLayout, styleProperties, siteFonts, siteFontsSpxResolved, isMobileView, isOneDocMigrated }) => {
		const compInfo = { compLayout, styleProperties, siteFonts, siteFontsSpxResolved, isMobileView }
		return {
			'--fnt': getScaledFont(compInfo, 'fnt', isOneDocMigrated),
		}
	}
)
